export var version = '3.7.8';
//# sourceMappingURL=version.js.map